import { render } from "./ArticleSection.vue?vue&type=template&id=562c50be&scoped=true"
import script from "./ArticleSection.vue?vue&type=script&lang=js"
export * from "./ArticleSection.vue?vue&type=script&lang=js"

import "./ArticleSection.vue?vue&type=style&index=0&id=562c50be&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/kama-dugri/kama-dugri/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562c50be"]])

export default __exports__